<template>
  <div>
    <!-- <sidenav
      ref="sidenav"
      :is-sidebar-active.sync="isSidebarActive"
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      :units="unitOptions"
      :center-options="centerOptions"
      :sector-options="sectorOptions"
      :camera-type-options="cameraTypeOptions"
      :reseller-options="resellerOptions"
      :proxy-rtsp-servers-options="proxyRtspServersOptions"
      @refetch-data="refetchData"
    /> -->

    <toastification-loading-content ref="loadingToast" />

    <WizardModal
      modal-id="wizard-modal"
      :is-active.sync="isWizardActive"
      :is-add="isAdd"
      :wizard-title="wizardTitle"
      :steps="wizardSteps"
      :step-icons="wizardStepIcons"
      :finishAtStep="finishAtStep"
      :current-step="currentStep"
      :show-previous-button="currentStep > 0"
      :show-save-button="!isAdd && currentStep < finishAtStep"
      :show-next-button="currentStep < finishAtStep"
      :show-finish-button="currentStep === finishAtStep"
      @close-wizard="closeWizard"
      @prev-step="prevStep"
      @next-step="nextStep"
      @load-data="loadData"
      @reset-wizard="resetData"
      @on-submit="submitSelection"
      @save-changes="submitSelection"
    >
      <template #step-0="{ currentStep, loading }">
        <InfoStep
          ref="infoStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          :typeOptions="cameraTypeOptions"
          :proxy-rtsp-servers-options="proxyRtspServersOptions"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <template #step-1="{ currentStep, loading }">
        <LocationStep
          ref="locationStepRef"
          :is-add.sync="isAdd"
          :prop-item-data="itemData"
          :unitOptions="unitOptions"
          :centerOptions="centerOptions"
          :sectorOptions="sectorOptions"
          :resellerOptions="resellerOptions"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <template #step-2="{ currentStep, loading }">
        <RecordingStep
          ref="recordingStepRef"
          :is-add="isAdd"
          :prop-item-data="itemData"
          :selected-limit="selectedLimit"
          @update:itemData="itemData = { ...itemData, ...$event }"
        />
      </template>
      <template #step-4="{ currentStep, loading }">
        <StreamStep
          ref="streamStepRef"
          :is-add="isAdd"
          :prop-item-data="itemData"
          @update:itemData="itemData = { ...itemData, ...$event }"
          @content-toast="contentToast"
        />
      </template>
      <template #step-3="{ currentStep, loading }">
        <PathConfigurationStep
          ref="pathConfigStepRef"
          :is-add="isAdd"
          :prop-item-data="itemData"
          @update:itemData="itemData = { ...itemData, ...$event }"
          @content-toast="contentToast"
        />
      </template>
    </WizardModal>

    <b-row class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>
    <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters
          :center-filter.sync="centerFilter"
          :center-options="centerOptions"
          :sector-filter.sync="sectorFilter"
          :sector-options="sectorOptions"
          :tenant-filter.sync="tenantFilter"
          :tenant-options="tenantOptions"
          :online-filter.sync="onlineFilter"
          :rtsp-available-filter.sync="rtspAvailableFilter"
          :enabled-onvif-event-filter.sync="enabledOnvifEventFilter"
          :reseller-options="resellerOptions"
          :reseller-filter.sync="resellerFilter"
          :camera-type-options="cameraTypeOptions"
          :camera-type-filter.sync="cameraTypeFilter"
          :on-demand-filter.sync="onDemandFilter"
          :recording-enable-filter.sync="recordingEnableFilter"
          :proxy-rtsp-servers-filter.sync="proxyRtspServersFilter"
          :proxy-rtsp-servers-options="proxyRtspServersOptions"
        />
      </template>
      <template v-slot:footer-buttons>
        <b-button
          variant="info"
          size="sm"
          class="text-capitalize"
          :disabled="buttonUpdate"
          @click="openUpdateCameras"
        >
          {{ $t("actions.update") + " " + $tc("camera.title", 2) }}
        </b-button>
      </template>
    </filter-modal>
    <SyncDevicesModal
      @loadingSyncDevices="loadingSyncDevices"
      :proxyRtspServersOptions="proxyRtspServersOptions"
      :proxyRtspServersFilter="proxyRtspServersFilter"
    />
    <!-- Table Container Card -->
    <b-card-group deck class="mx-2">
      <b-card class="m-0" no-body>
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                />
                <b-button
                  variant="secondary"
                  @click="openWizard()"
                  v-if="$can('create', 'GenericDevice')"
                >
                  <span class="text-nowrap text-capitalize">
                    {{ $t("generic_devices.add_device") }}
                  </span>
                </b-button>
                <b-button
                  v-b-modal.import_file
                  variant="info"
                  class="text-capitalize ml-1"
                  type="button"
                  :disabled="buttonExport"
                  v-b-tooltip.hover
                  v-if="$can('create', 'GenericDevice')"
                  :title="`${$t('messages.import.title')}`"
                >
                  <feather-icon icon="UploadCloudIcon" size="15" />
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Modal Import -->
        <div v-if="$can('create', 'GenericDevice')">
          <b-modal
            id="import_file"
            :title="`${$t('messages.import.title')}`"
            no-close-on-esc
            no-close-on-backdrop
            ref="modalImport"
          >
            <vue-dropzone
              id="dropzone_file"
              ref="dropzoneFile"
              :options="dropzoneOptions"
              class="dropzone-file"
              @vdropzone-file-added="addFile"
              @vdropzone-removed-file="removeFile"
            />
            <div v-if="importMessage.length > 0" class="mt-2 scroll">
              <span v-for="(message, index) in importMessage" :key="index">
                <p
                  class="text-danger mb-0"
                  v-for="(error, index) in message"
                  :key="index"
                >
                  {{ error }}
                </p>
              </span>
            </div>
            <template #modal-footer>
              <a :href="import_example_url" download>{{
                $t("messages.import.example_file")
              }}</a>
              <b-button
                variant="secondary"
                class="text-capitalize"
                @click="$bvModal.hide('import_file')"
              >
                {{ $t("actions.cancel") }}
              </b-button>
              <b-button variant="primary" @click="importExcel" class="text-capitalize">
                {{ $t("actions.accept") }}
              </b-button>
            </template>
          </b-modal>
        </div>

        <ModalPath
          :genericDevice="currentDeviceSelect"
          :isModalPathActive="isModalPathActive"
          @close-modal="closeModalPath"
          :is-active.sync="isModalPathActive"
          v-if="isModalPathActive"/>
        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #head()="data">
            <span> {{ $tc(data.label, 1) }}</span>
          </template>

          <template #cell(title)="data">
            <b-media vertical-align="center">
              <template #aside>
                <div
                  :style="`background: ${data.item.online ? 'green' : 'red'};
                                width: 1.5rem;
                                height: 1.5rem;
                                border-radius: 1rem;
                                text-align: center;`"
                ></div>
              </template>
              <!-- <small>{{ data.item.title }}</small> -->
            </b-media>
          </template>

          <template #head(name)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #head(provider)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #head(type)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #head(center)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #head(sector)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #cell(data)="data">
            <pre v-if="data.item.data">{{
              JSON.stringify(data.item.data, null, "\t")
            }}</pre>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              :id="`actions-${data.item.id}`"
              tabindex="0"
              variant="white"
              class="px-1 btn-y"
            >
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </b-button>
            <b-popover
              :target="`actions-${data.item.id}`"
              triggers="focus"
              placement="bottom"
              custom-class="popover-p-0"
              variant="white"
            >
              <b-list-group class="m-0">
                <b-list-group-item
                  v-if="$can('update', 'GenericDevice')"
                  class="border-0"
                  button
                  @click="openEdit(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50 text-capitalize">
                    {{ $t("actions.edit") }}
                  </span>
                </b-list-group-item>
                <b-list-group-item
                  v-if="$can('delete', 'GenericDevice')"
                  class="border-0"
                  button
                  @click="confirmDelete(data.item.id)"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50 text-capitalize">
                    {{ $t("actions.delete") }}
                  </span>
                </b-list-group-item>
                <b-list-group-item
                  class="border-0"
                  button
                  @click="openModalPath(data.item)"
                >
                  <feather-icon icon="ActivityIcon" />
                  <span class="align-middle ml-50 text-capitalize">
                    Path Information
                  </span>
                </b-list-group-item>
              </b-list-group>
            </b-popover>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <Pagination
                :totalList="totalList"
                :currentPage="currentPage"
                @updatePagination="update"
                :perPage="perPage"
              >
              </Pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, computed } from "@vue/composition-api";
import useList from "./useList";
import Sidenav from "./Sidenav.vue";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import store from "@/store";
import axios from "@/libs/axios";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import Filters from "./Filters.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";

import WizardModal from "@/components/WizardModal/Index.vue";
import InfoStep from "./wizard/InfoStep.vue";
import LocationStep from "./wizard/LocationStep.vue";
import RecordingStep from "./wizard/RecordingStep.vue";
import StreamStep from "./wizard/StreamStep.vue";
import ModalPath from "./ModalPath.vue";
import PathConfigurationStep from "./wizard/PathConfigurationStep.vue";
import SyncDevicesModal from "./SyncDevicesModal.vue";

export default {
  components: {
    BreadcrumbMenu,
    Sidenav,
    Filters,
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ToastificationLoadingContent,
    FilterModal,
    ButtonFilters,

    WizardModal,
    InfoStep,
    LocationStep,
    RecordingStep,
    StreamStep,
    ModalPath,
    PathConfigurationStep,
    SyncDevicesModal
  },
  setup(_, { emit }) {
    const isSidebarActiveByChatbot = store.getters["chatbot/getIsSidebarActive"];
    //start pagination
    const update = (data) => {
      useListData.currentPage.value = data;
    };
    //end pagination
    // start export
    const action = ref("list");

    const infoStepRef = ref(null);
    const locationStepRef = ref(null);
    const recordingStepRef = ref(null);
    const streamStepRef = ref(null);
    const pathConfigStepRef = ref(null);

    const isWizardActive = ref(false);
    const isAdd = ref(isSidebarActiveByChatbot);
    const itemEdit = ref({});
    const currentStep = ref(0);
    const selectedLimit = ref(null);
    const wizardTitle = ref("Camera Setup Wizard");
    const currentDeviceSelect = ref(null);
    const isModalPathActive = ref(false);
    const wizardSteps = ["Información", "Ubicación", "Grabación", "Script", "Transmisión"];
    const wizardStepIcons = ["ToolIcon", "MapIcon", "VideoIcon", "BookOpenIcon", "MonitorIcon"];
    const finishAtStep = computed(() => (isAdd.value ? 2 : 4));

    const blankData = {
      // infoStep
      name: "",
      provider: "",
      type: "camera",
      protocol: "rtsp",
      url: "",
      id_type: 3,
      id_device_tag: null,
      user: "",
      password: "",
      onvif_url: "",
      onvif_port: 80,
      rtsp_available: 0,
      on_demand: 0,
      enabled_onvif_events: 0,

      data: {
        on_demand: 0,
        recording_enable: 0,
        record_limit: 0,
        enabled_onvif_events: 0,
      },

      // locationStep
      units: [],
      id_center: null,
      id_sector: null,
      id_omniview_reseller: null,

      //recording step
      delayed_record_minutes: "00:00:10",
      forward_record_minutes: "00:00:10",
      record_limit: null,
    };
    const itemData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankData));
    };

    const buttonUpdate = ref(false);
    const isSidebarActive = ref(isSidebarActiveByChatbot);
    const modalImport = ref();
    const loadingToast = ref();

    const openWizard = () => {
      isAdd.value = true;
      isWizardActive.value = true;
      currentStep.value = 0;
      resetData();
    };

    const closeWizard = () => {
      resetData();
      currentStep.value = 0;
      isWizardActive.value = false;
    };

    const openEdit = (item) => {
      isAdd.value = false;
      itemEdit.value = item;
      itemData.value = { ...blankData, ...item };
      isWizardActive.value = true;
      currentStep.value = 0;
    };

    const openUpdateCameras = function () {
      this.$bvModal.show("sync-generic-devices");
    };

    const useListData = useList();
    const {
      clearSearchFilters,
      buildFilters,
      filtersCount,
      refetchData,
      onlineFilter,
      rtspAvailableFilter,
      enabledOnvifEventFilter,

      centerOptions,
      sectorOptions,
      resellerOptions,
    } = useListData;

    const toast = useToast();

    const { t } = useI18nUtils();
    const buttonExport = ref(false);
    const trans = {
      "messages.import.upload": t("messages.import.upload"),
      "messages.import.uploading_file": t("messages.import.uploading_file"),
      "messages.import.upload_succesfully": t("messages.import.upload_succesfully"),
      "messages.export.download": t("messages.export.download"),
      "messages.export.Generating_file": t("messages.export.Generating_file"),
      "messages.error.server_error": t("messages.error.server_error"),
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
      "actions.synchronizing": t("actions.synchronizing"),
      "generic_devices.title": t("generic_devices.title"),
    };

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: trans["messages.delete.title"],
        text: trans["messages.delete.body"],
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: trans["actions.delete"],
        cancelButtonText: trans["actions.cancel"],
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("generic_devices/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const dropzoneOptions = ref({
      url: "https://httpbin.org/post",
      paramName: "file",
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictRemoveFile: t("actions.delete"),
      acceptedFiles: ".xlsx,.xls",
      maxFilesize: 10,
      dictDefaultMessage: t("messages.import.select_file") + " (.xlsx .xls)",
    });

    const dropzoneFile = ref(null);
    const importMessage = ref([]);

    const addFile = (file) => {
      importMessage.value = [];
      dropzoneFile.value = file;
      if (file.size > 10000000) {
        dropzoneFile.value = null;
      }
    };

    const removeFile = () => {
      dropzoneFile.value = null;
    };

    const importExcel = function () {
      const self = this;
      if (dropzoneFile.value == null) return;

      loadingToast.value.show(
        trans["messages.import.upload"],
        trans["messages.import.uploading_file"],
        "secondary"
      );
      buttonExport.value = true;

      let formData = new FormData();
      formData.append("file", dropzoneFile.value);
      formData.append("action", "import");

      store
        .dispatch("generic_devices/add", formData)
        .then(function (response) {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            modalImport.value.hide();
            self.refetchData();
          }
        })
        .catch((response) => {
          if (response.response.status == 400) {
            const link = document.createElement("a");
            link.href = response.response.data.data.url;
            link.setAttribute("download", "error.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.response.data.message}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            modalImport.value.hide();
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.response.data.message}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
          importMessage.value = response.response.data.data;
          loadingToast.value.close();
        })
        .finally(() => {
          loadingToast.value.close();
          buttonExport.value = false;
        });
    };

    const prevStep = () => {
      if (currentStep.value > 0) {
        currentStep.value--;
      }
    };

    const changeCenter = () => {
      store
        .dispatch("sector/getAll", {
          id_center: [itemData.value.id_center],
        })
        .then(() => {
          const sectors = Array.isArray(sectorOptions.value) ? sectorOptions.value : [];
          const sector = sectors.filter(
            (item) => item.value === itemData.value.id_sector
          );
          if (sector.length == 0) itemData.value.id_sector = "";
        });
    };

    const updateDeviceTags = () => {
      if (itemData.value.id_unit) {
        const idTenants = itemData.value.id_unit.map((unit) => unit.id_tenant);
        store.dispatch("tenant/getDeviceTagsByTenantIds", {
          id_tenants: idTenants,
        });
      }
    };

    const nextStep = async () => {
      let isValid = true;

      // Validar cada paso basado en el índice de `currentStep`
      if (
        currentStep.value === 0 &&
        infoStepRef.value &&
        typeof infoStepRef.value.validateStep === "function"
      ) {
        isValid = await infoStepRef.value.validateStep();
      } else if (
        currentStep.value === 1 &&
        locationStepRef.value &&
        typeof locationStepRef.value.validateStep === "function"
      ) {
        isValid = await locationStepRef.value.validateStep();
      } else if (
        currentStep.value === 2 &&
        recordingStepRef.value &&
        typeof recordingStepRef.value.validateStep === "function"
      ) {
        isValid = await recordingStepRef.value.validateStep();
      } else if (
        currentStep.value === 4 &&
        streamStepRef.value &&
        typeof streamStepRef.value.validateStep === "function"
      ) {
        isValid = await streamStepRef.value.validateStep();
      } else if (
        currentStep.value === 3 &&
        pathConfigStepRef.value &&
        typeof pathConfigStepRef.value.validateStep === "function"
      ) {
        isValid = await pathConfigStepRef.value.validateStep();
      }

      if (isValid) {
        currentStep.value++;
      }
    };

    const contentToast = (message, type) => {
      console.log(message, type)
      toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckIcon",
          variant: type,
        },
      });
    }


    const loadData = () => {
      if (!isAdd.value) {
        itemData.value = {
          ...itemEdit.value,
          ...itemEdit.value.data
        };

        if (itemData.value.units.length) {
          itemData.value.units = itemEdit.value.units.map((value) => ({
            value: value.id,
            label: value.description,
          }));
          updateDeviceTags(itemData.value.units);
        }
        changeCenter();
      } else {
        if (centerOptions.length == 1) itemData.value.id_center = centerOptions[0].value;

        if (sectorOptions.length == 1) itemData.value.id_sector = sectorOptions[0].value;

        if (resellerOptions.length == 1)
          itemData.value.id_omniview_reseller = resellerOptions[0].value;
      }
    };

    const submitSelection = (step) => {
      if (step != 4) {
        onSubmit()
      } else {
        onSubmiteOnvif()
      }
    }

    const onSubmiteOnvif = async () => {
      streamStepRef.value.saveChanges();
    }

    const openModalPath = (device) => {
      currentDeviceSelect.value = device
      isModalPathActive.value = true
    }

    const closeModalPath = () => {
      currentDeviceSelect.value = null
      isModalPathActive.value = false
    }

    const onSubmit = async () => {
      try {
        let message = "";

        itemData.value.data.on_demand = itemData.value.on_demand
          ? parseInt(itemData.value.on_demand)
          : 0;
        itemData.value.data.record_limit = itemData.value.record_limit ?? 0;
        itemData.value.data.recording_enable = itemData.value.recording_enable
          ? parseInt(itemData.value.recording_enable)
          : 0;
        const params = {
          ...itemData.value,
          data: {
            url: itemData.value.url,
            subUrl: itemData.value.subUrl,
            currentStream: itemData.value.currentStream ?? 'main',
            protocol: itemData.value.protocol,
            port: itemData.value.port,
            onvif_host: itemData.value.onvif_host,
            onvif_port: itemData.value.onvif_port,
            user: itemData.value.user,
            password: itemData.value.password,
            enabled_onvif_events: itemData.value.enabled_onvif_events,
            on_demand: itemData.value.on_demand,
            record_limit: itemData.value.record_limit,
            recording_enable: itemData.value.recording_enable,
          },
        };

        if (isAdd.value) {
          let { data } = await axios.post(`/v1/generic-devices`, {
            ...params,
          });
          message = data.message;
        } else {
          let { data } = await axios.put(`/v1/generic-devices/${itemData.value.id}`, {
            ...params,
          });
          message = data.message;
        }

        contentToast(message, "success");
        refetchData();
        closeWizard();
      } catch (response) {
        let message = "";
        if (response.response.status == 422) {
          let string = ``;
          Object.entries(response.response.data.data).forEach((entry) => {
            const [key, value] = entry;
            string += `${key} - ${value}<br>`;
          });

          message = string;
        } else {
          message = response.response.data.message;
        }
        contentToast(message, "danger");
      }
    };

    const loadingSyncDevices = function (show) {
      if (show) {
        loadingToast.value.show(
          trans["actions.synchronizing"],
          `${trans["actions.synchronizing"]}  ${trans["generic_devices.title"]}`,
          "secondary"
        );
        return;
      }

      loadingToast.value.close();
    };

    return {
      action,
      update,
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      buttonExport,
      importExcel,
      dropzoneOptions,
      addFile,
      removeFile,
      importMessage,
      loadingToast,
      modalImport,
      filtersCount,
      clearSearchFilters,
      buildFilters,
      refetchData,
      onlineFilter,
      rtspAvailableFilter,
      enabledOnvifEventFilter,
      import_example_url: `${window.__env.VUE_APP_BASE_URL}/import_examples/import_generic_devices.xlsx`,
      ...useListData,

      openWizard,
      isWizardActive,
      closeWizard,
      wizardTitle,
      wizardSteps,
      wizardStepIcons,
      currentStep,
      finishAtStep,
      prevStep,
      itemData,
      nextStep,
      infoStepRef,
      locationStepRef,
      recordingStepRef,
      streamStepRef,
      loadData,
      resetData,
      onSubmit,
      selectedLimit,

      submitSelection,

      contentToast,
      openModalPath,
      currentDeviceSelect,
      isModalPathActive,
      closeModalPath,
      openUpdateCameras,
      buttonUpdate,
      loadingSyncDevices
    };
  },
};
</script>

<style lang="scss">
.dropzone-file {
  padding: 0px;
  margin: auto;
  border: none;
  max-width: 250px;
  min-height: 200px;
  display: flex;
  box-shadow: inset 0 0 0 3px #dfdfdf;
}

.dropzone {
  .dz-preview {
    margin: 0px;
    width: 100%;
  }

  .dz-message {
    text-align: center;
    margin: auto;
  }
}

.scroll {
  width: 100%;
  height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
}

.scroll::-webkit-scrollbar {
  height: 5px;
  width: 10px;
}

.scroll::-webkit-scrollbar-thumb {
  background: #1b3d5e;
}
</style>
